import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { InvoicePaymentEventsApi } from "src/api/generated/erp/sales/invoicing/api/invoicePaymentEventsApi.ts";
import { AavoDataGrid } from "src/components/common/dataGrid/AavoDataGrid.tsx";
import { dateColumn, moneyColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { InvoicePaymentEvent } from "src/api/generated/erp/accountingIntegration/model/invoicePaymentEvent.ts";
import { formatLabelWithCurrencyCode, renderMoneyCellWithCurrency } from "src/components/views/erp/sales/salesUtils.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface InvoicePaymentEventsDataGridProps {
	invoiceId: number;
	currencyCode: string;
}

export const InvoicePaymentEventsDataGrid = ({ invoiceId, currencyCode }: InvoicePaymentEventsDataGridProps) => {
	return (
		<ClientSideDataGridModel<InvoicePaymentEvent[], InvoicePaymentEvent, object>
			fetchData={() => InvoicePaymentEventsApi.getInvoicePaymentEvents({ invoiceId })}
			initialParams={{}}
			getRowId={(row) => row.id}
			getRows={(data) => data}
			gridId={"E34A42936386F00D"}
			render={({ dataGridProps }) => (
				<AavoDataGrid<InvoicePaymentEvent>
					columns={[
						dateColumn({
							field: "paymentDate",
							headerName: i18n.t("date"),
							width: 120,
						}),
						moneyColumn({
							field: "amount",
							headerName: formatLabelWithCurrencyCode(i18n.t("amount"), currencyCode),
							width: 120,
							renderCell: renderMoneyCellWithCurrency(currencyCode),
						}),
					]}
					agentContext={{
						key: defineAgentUiContextKey("erp.sales.invoicePaymentEvents.grid"),
						data: { invoiceId },
						rowFields: ["id", "paymentDate", "amount"],
						selectedRowPathSegment: (row) => `${i18n.t("payment_events")} ${row.id}`,
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
